import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/quick-help";
const store = {};
const mutations = {
    GET_CURRENT_ENTRY(state, post) {
        state.quickHelp = post;
    },
};
const state = {
    quickHelp: {
        Visible: false,
        EditorVisible: false,
        Title: "",
        Text: "",
        HepId: 0,
        HasEntry: false
    }
};
const getters = {};
const actions = {
    getQuickHelp({ commit }, { pageTitle }) {
        var path = window.location.pathname;
        var page = path.split("/").pop();
        return axios
            .get(baseUri + '/CurrentEntry', { params: { localPath: path, pageTitle, hepClassName: page } })
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_CURRENT_ENTRY', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}